import React from 'react';
import { Box, Typography } from '@mui/material';

import { IChunkModel } from '@common/models/Chunks/Chunk';

interface PropsType {
	chunkModel: IChunkModel;
}

function ChunkTitle({ chunkModel }: PropsType) {
	return (
		<Box sx={{ textAlign: 'center' }}>
			<Typography
				component="h3"
				sx={{ margin: 0, fontSize: '20px', fontWeight: 700 }}
			>
				{chunkModel.title}
			</Typography>
		</Box>
	);
}

export default ChunkTitle;
